import { render, staticRenderFns } from "./SimpleAppTable.vue?vue&type=template&id=593f6a35&scoped=true"
import script from "./SimpleAppTable.vue?vue&type=script&lang=ts"
export * from "./SimpleAppTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f6a35",
  null
  
)

export default component.exports